import { BlogLayout } from "@/components/layout/BlogLayout";

export default function Privacy() {
  return (
    <BlogLayout title="Política de Privacidade">
      <article className="prose prose-invert mx-auto max-w-3xl px-4 py-12">
        <h1>Política de Privacidade</h1>
        <p className="text-muted-foreground">Última atualização: 14 de fevereiro de 2026</p>

        <h2>1. Introdução</h2>
        <p>
          O fotoCerta ("nós", "nosso") está comprometido em proteger sua privacidade. Esta
          Política de Privacidade explica como coletamos, usamos, armazenamos e protegemos
          suas informações pessoais em conformidade com a Lei Geral de Proteção de Dados
          (LGPD — Lei nº 13.709/2018).
        </p>

        <h2>2. Dados que Coletamos</h2>
        <h3>2.1 Dados fornecidos por você</h3>
        <ul>
          <li><strong>Dados de cadastro:</strong> nome, e-mail (via Google OAuth ou link mágico)</li>
          <li><strong>Dados de perfil:</strong> gênero, idade</li>
          <li><strong>Fotos:</strong> imagens enviadas para avaliação</li>
          <li><strong>Avaliações:</strong> notas e comentários sobre fotos de outros usuários</li>
        </ul>

        <h3>2.2 Dados coletados automaticamente</h3>
        <ul>
          <li><strong>Dados de uso:</strong> páginas visitadas, interações com o Serviço, horários de acesso</li>
          <li><strong>Dados do dispositivo:</strong> tipo de navegador, sistema operacional, endereço IP</li>
          <li><strong>Cookies e tecnologias semelhantes:</strong> utilizamos cookies para manter sua sessão e melhorar a experiência</li>
        </ul>

        <h3>2.3 Dados de pagamento</h3>
        <p>
          Pagamentos são processados por terceiros (Stripe e OpenPix). Não armazenamos dados
          de cartão de crédito ou informações bancárias. Armazenamos apenas o status e
          referência da transação.
        </p>

        <h2>3. Como Usamos seus Dados</h2>
        <ul>
          <li>Fornecer e manter o Serviço</li>
          <li>Exibir suas fotos para avaliação por outros usuários</li>
          <li>Filtrar avaliadores por critérios demográficos (idade, gênero)</li>
          <li>Processar pagamentos e gerenciar créditos</li>
          <li>Enviar comunicações sobre o Serviço (e-mails transacionais)</li>
          <li>Analisar o uso da plataforma para melhorias (analytics)</li>
          <li>Prevenir fraudes e abusos</li>
        </ul>

        <h2>4. Base Legal para o Tratamento</h2>
        <p>Tratamos seus dados com base nas seguintes hipóteses legais da LGPD:</p>
        <ul>
          <li><strong>Consentimento:</strong> ao criar sua conta e enviar fotos</li>
          <li><strong>Execução de contrato:</strong> para fornecer o Serviço contratado</li>
          <li><strong>Legítimo interesse:</strong> para melhorias do Serviço e prevenção de fraudes</li>
        </ul>

        <h2>5. Compartilhamento de Dados</h2>
        <p>Seus dados podem ser compartilhados com:</p>
        <ul>
          <li><strong>Outros usuários:</strong> suas fotos são exibidas para avaliação (sem revelar sua identidade ao avaliador)</li>
          <li><strong>Prestadores de serviço:</strong> Cloudflare (armazenamento de imagens), Stripe e OpenPix (pagamentos), PostHog (analytics), Google (autenticação)</li>
        </ul>
        <p>
          Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para
          fins de marketing.
        </p>

        <h2>6. Armazenamento e Segurança</h2>
        <p>
          Seus dados são armazenados em servidores seguros. Utilizamos criptografia em
          trânsito (HTTPS) e em repouso. Imagens são armazenadas na Cloudflare Images.
          O banco de dados é hospedado na Neon (PostgreSQL gerenciado).
        </p>

        <h2>7. Seus Direitos (LGPD)</h2>
        <p>Você tem o direito de:</p>
        <ul>
          <li>Confirmar a existência de tratamento de seus dados</li>
          <li>Acessar seus dados pessoais</li>
          <li>Corrigir dados incompletos ou desatualizados</li>
          <li>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
          <li>Solicitar a portabilidade dos dados</li>
          <li>Revogar seu consentimento a qualquer momento</li>
          <li>Solicitar a exclusão de sua conta e dados</li>
        </ul>
        <p>
          Para exercer seus direitos, entre em contato pelo e-mail{" "}
          <a href="mailto:contato@fotocerta.com">contato@fotocerta.com</a>.
        </p>

        <h2>8. Retenção de Dados</h2>
        <p>
          Mantemos seus dados enquanto sua conta estiver ativa. Após a exclusão da conta,
          seus dados pessoais serão removidos em até 30 dias, exceto quando a retenção for
          necessária por obrigação legal.
        </p>

        <h2>9. Cookies</h2>
        <p>
          Utilizamos cookies essenciais para o funcionamento do Serviço (sessão de login) e
          cookies de analytics (PostHog) para entender o uso da plataforma. Você pode
          gerenciar cookies nas configurações do seu navegador.
        </p>

        <h2>10. Menores de Idade</h2>
        <p>
          O Serviço não é destinado a menores de 18 anos. Não coletamos intencionalmente
          dados de menores. Se identificarmos uma conta de menor, ela será encerrada
          imediatamente.
        </p>

        <h2>11. Alterações nesta Política</h2>
        <p>
          Podemos atualizar esta Política periodicamente. Notificaremos sobre alterações
          significativas por e-mail ou aviso na plataforma.
        </p>

        <h2>12. Contato</h2>
        <p>
          Para dúvidas sobre esta Política de Privacidade ou sobre o tratamento de seus dados,
          entre em contato:
        </p>
        <ul>
          <li><strong>E-mail:</strong> <a href="mailto:contato@fotocerta.com">contato@fotocerta.com</a></li>
        </ul>
      </article>
    </BlogLayout>
  );
}
